var map = {
	"./HALLAM/config": "be71",
	"./HALLAM/config.js": "be71",
	"./HALLAM/logo/dark-logo.png": "2189",
	"./HALLAM/logo/logo-english.png": "919a",
	"./KAHRABA/config": "d042",
	"./KAHRABA/config.js": "d042",
	"./KAHRABA/logo/dark-logo.png": "2bb5",
	"./KAHRABA/logo/logo-ar.png": "2438",
	"./KAHRABA/logo/logo-en.png": "0bba",
	"./MC/config": "9771",
	"./MC/config.js": "9771",
	"./MC/logo/dark-logo.png": "7024",
	"./MC/logo/footer-background.png": "7a1f",
	"./MC/logo/logo-ar.png": "8a54",
	"./MC/logo/logo-en.png": "3e92",
	"./PYLON/config": "a3d8",
	"./PYLON/config.js": "a3d8",
	"./PYLON/logo/dark-logo.png": "e140",
	"./PYLON/logo/footer-logo.png": "1220",
	"./TMG/config": "7bd2",
	"./TMG/config.js": "7bd2",
	"./TMG/logo/dark-logo.png": "0be2",
	"./TMG/logo/footer-logo.png": "daef",
	"./UDCL/config": "82f8",
	"./UDCL/config.js": "82f8",
	"./UDCL/logo/dark-logo.png": "068f",
	"./UDCL/logo/footer-logo.png": "609a"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "10fe";